import { Box } from '@chakra-ui/react';
import { Text, Link } from 'components/UI';
import { PageTitle } from 'components/common/PageTitle';
import AppRoutes from 'constants/routes';

const AccessDenied = () => (
  <Box py={6} textAlign="center" w="full" data-testid="access-denied">
    <PageTitle mb={4}>Access Denied</PageTitle>
    <Text mb={6}>You do not have permission to access this page.</Text>
    <Link variant="button" to={AppRoutes.Landing}>
      BACK TO HOME
    </Link>
  </Box>
);

export default AccessDenied;
